import { Pagination } from 'antd';
import { alarmApi } from 'api/alarmApi';
import { useAppSelector } from 'app/hooks';
import { selectUserInfo } from 'components/Layout/homeSlice';
import { ListResponse } from 'models';
import { alarmInfo, statusAlarm } from 'models/alarm';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { selectInverterItemSidebar, selectPlantItemSidebar } from '../Sidebar/sidebarSlice';
import style from './Alarm.module.scss';
import TableDetail from './components/TableAlarm/Table';
export interface AlarmProps {}

export default function Alarm(props: AlarmProps) {
  const match = useRouteMatch();
  const [typeAlarm, setTypeAlarm] = useState<string>('');
  const plantItemSelected = useAppSelector(selectPlantItemSidebar);
  const inverterItemSelected = useAppSelector(selectInverterItemSidebar);
  const userInfo = useAppSelector(selectUserInfo);
  const [alarmList, setAlarmList] = useState<ListResponse<alarmInfo> | null>(null);
  const [numberPage, setNumberPage] = useState<number>(0);
  const [valueAlarm, setValueAlarm] = useState<statusAlarm>({
    active_or_cleared: 'ACTIVE',
    acknowledged_or_unacknowledged: 'ALL',
    severity: 'ALL',
  });

  const [rangeTime, setRangeTime] = useState([
    moment().subtract(30, 'days').format('YYYY-MM-DD'),
    moment().format('YYYY-MM-DD'),
  ]);

  useEffect(() => {
    if (plantItemSelected || inverterItemSelected || userInfo) {
      (async () => {
        try {
          let type = '';
          if (match.url.indexOf('/plant/') !== -1) {
            type = 'ASSET';
          } else if (match.url.indexOf('/inverter/') !== -1) {
            type = 'DEVICE';
          } else {
            type = 'USER';
          }
          setTypeAlarm(type);
          const response: ListResponse<alarmInfo> = await alarmApi.fetchAlarmList({
            type_Filter: type,
            id:
              type === 'ASSET'
                ? plantItemSelected
                : type === 'DEVICE'
                ? inverterItemSelected
                : userInfo?.id,
            severity: valueAlarm.severity,
            active_or_cleared: valueAlarm.active_or_cleared,
            acknowledged_or_unacknowledged: valueAlarm.acknowledged_or_unacknowledged,
            start_ts: moment(rangeTime[0]).startOf('days').valueOf(),
            end_ts: moment(rangeTime[1]).endOf('days').valueOf(),
            _limit: 20,
            _page: numberPage,
          });
          setAlarmList(response);
        } catch (error) {
          console.log('Failed to fetch plant details', error);
        }
      })();
    }
  }, [plantItemSelected, inverterItemSelected, userInfo]);

  const onChangePage = async (page: number) => {
    setNumberPage(page - 1);
    const response: ListResponse<alarmInfo> = await alarmApi.fetchAlarmList({
      type_Filter: typeAlarm,
      id:
        typeAlarm === 'ASSET'
          ? plantItemSelected
          : typeAlarm === 'DEVICE'
          ? inverterItemSelected
          : userInfo?.id,
      start_ts: moment(rangeTime[0]).startOf('days').valueOf(),
      end_ts: moment(rangeTime[1]).endOf('days').valueOf(),
      severity: valueAlarm.severity,
      active_or_cleared: valueAlarm.active_or_cleared,
      acknowledged_or_unacknowledged: valueAlarm.acknowledged_or_unacknowledged,
      _limit: 20,
      _page: page - 1,
    });
    setAlarmList(response);
  };

  const footerTableAlarm = () => (
    <>
      <div className={style.acknowledge}>
        Total:&ensp;
        {alarmList && alarmList.total_elements}
      </div>
      {alarmList ? (
        <Pagination
          size="small"
          onChange={onChangePage}
          pageSize={20}
          defaultCurrent={1}
          total={alarmList.total_elements}
          showSizeChanger={false}
          showQuickJumper={false}
        />
      ) : (
        <div></div>
      )}
    </>
  );

  return (
    <div className={style.root}>
      <div className={style.content}>
        {alarmList && (
          <TableDetail
            alarmList={alarmList.data}
            valueAlarm={valueAlarm}
            setValueAlarm={setValueAlarm}
            typeAlarm={typeAlarm}
            setAlarmList={setAlarmList}
            numberPage={numberPage}
            rangeTime={rangeTime}
            setRangeTime={setRangeTime}
          />
        )}
      </div>
      <div className={style.footer}>{footerTableAlarm()}</div>
    </div>
  );
}
